module.exports = __webpack_public_path__ + "static/media/offerte.861e37cd.jpg";